export const SETTASKSLIST = "SETTASKSLIST";
export const SETTASKSTATUSLIST = "SETTASKSTATUSLIST";
export const SETEMPLOYEELIST = "SETEMPLOYEELIST";
export const SETSUPERUSER = "SETSUPERUSER";
export const SETTASK = "SETTASK";